/**
 * Components / Custom / Page > Newsflash
 */

import {
	executeAfterTransition,
	triggerReflow
} from '@ifabnpm/bootstrap/utils.js';
import {
	lockBodyScrolling,
	unlockBodyScrolling
} from '@ifabnpm/bootstrap/utils/scroll.js';
import {getTabbableElements} from '@ifabnpm/bootstrap/utils/tabbable.js';
import FocusTrap from '@ifabnpm/bootstrap/utils/focustrap.js';

import SelectorEngine from '@ifabnpm/bootstrap/dom/selector-engine.js';
import EventHandler from '@ifabnpm/bootstrap/dom/event-handler.js';
import Manipulator from '@ifabnpm/bootstrap/dom/manipulator.js';

// --------
// Let's go
// --------

document.addEventListener('DOMContentLoaded', () => {
	const container = SelectorEngine.findOne('[data-newsflash]');

	if (container) {
		const id               = container.dataset.newsflash;
		const storageItem      = localStorage.getItem(`${window.pageInstance.prefix}newsflash`);
		const storageData      = (storageItem) ? JSON.parse(storageItem) : [];
		const tabbableElements = getTabbableElements(container);

		let focustrap;

		if (storageData.indexOf(id) >= 0) {
			container.remove();
		} else {
			let currentActiveElement;

			EventHandler.on(container, 'show.newsflash', (event) => {
				currentActiveElement = document.activeElement;

				event.target.hidden = false;

				lockBodyScrolling(container);

				triggerReflow(event.target);

				Manipulator.addClass(event.target, '-show');

				executeAfterTransition(() => {
					// Cookie-Consent-Panels (Test um den Fokus auf des Schließenbutton setzten zu können)
					const consentPanels = SelectorEngine.find('.sc-cookie-banner.-shown, .sc-cookie-preferences.-shown');

					// Gibt es keine Cookie-Consent-Panels, dann setze den Fokus auf den Schließenbutton.
					if (consentPanels.length === 0) {
						EventHandler.trigger(container, 'activate.newsflash');
					} else {
						EventHandler.trigger(container, 'deactivate.newsflash');
					}
				}, event.target);
			});

			EventHandler.on(container, 'hide.newsflash', (event) => {
				Manipulator.removeClass(event.target, '-show');
				Manipulator.addClass(event.target, '-hide');

				storageData.push(id);

				localStorage.setItem(`${window.pageInstance.prefix}newsflash`, JSON.stringify(storageData));

				if (focustrap) {
					focustrap.deactivate();
				}

				executeAfterTransition(() => {
					event.target.remove();

					if (currentActiveElement && typeof currentActiveElement.focus === 'function') {
						setTimeout(() => currentActiveElement.focus());
					}

					unlockBodyScrolling(container);
				}, event.target);
			});

			EventHandler.on(container, 'click.newsflash', 'button[data-close]', (event) => {
				EventHandler.trigger(container, 'hide.newsflash');
			});

			EventHandler.on(container, 'activate.newsflash', (event) => {
				Manipulator.removeClass(container, '-deactivated');

				focustrap = new FocusTrap(container);

				focustrap.activate();

				if (tabbableElements.length > 0) {
					tabbableElements[0].focus({preventScroll: true});
				}
			});

			EventHandler.on(container, 'deactivate.newsflash', (event) => {
				Manipulator.addClass(container, '-deactivated');

				if (focustrap) {
					focustrap.deactivate();
				}
			});

			setTimeout(() => {
				EventHandler.trigger(container, 'show.newsflash');
			}, 2000);
		}
	}
});
